import { SlButton } from "@shoelace-style/shoelace/dist/react";
import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import API from "../../services/api";
import { Toast } from "../../shared/Toast";
import Select from "react-select";
import { newspaperLangs, adPositions } from "../../utils/constants.js";

function NetworkAdStats(props) {
  const { adPartnerData, loadData, setShow, loadStats, statsData, setStats ,loadAdData,loadPositionData} = props;
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    reset,
  } = useForm({
    defaultValues: {
      date: "",
      requests: "",
      impression: "",
      clicks: "",
      ecpm: "",
      revenue: "",
      ad_code: "",
      lang_id: { value: 1, label: "Telugu" },
      position: { value: 0, label: "0" },
    },
  });

  const positionOptions = adPositions
    .filter((pos) => pos !== -1)
    .map((pos) => ({
      value: pos,
      label: pos.toString(),
    }));


  // Prefill form for editing
  useEffect(() => {
    if (statsData && Object.keys(statsData).length > 0) {
      const lang = newspaperLangs.find((item) => item.value === statsData?.lang_id);
      const pos = positionOptions.find((item) => item.value === statsData?.position);
      reset({
        date: statsData.date
          ? new Date(statsData.date * 1000).toLocaleDateString("en-CA", {
              timeZone: "Asia/Kolkata",
            })
          : "",
        requests: statsData.requests?.toString() || "",
        impression: statsData.impression?.toString() || "",
        clicks: statsData.clicks?.toString() || "",
        ecpm: statsData.ecpm?.toString() || "",
        revenue: statsData.revenue?.toString() || "",
        ad_code: statsData.ad_code || "",
        lang_id: lang || { value: 1, label: "Telugu" },
        position: pos || { value: 0, label: "0" },
      });
    } else {
      reset({
        date: "",
        requests: "",
        impression: "",
        clicks: "",
        ecpm: "",
        revenue: "",
        ad_code: "",
        lang_id: { value: 1, label: "Telugu" },
        position: { value: 0, label: "0" },
      });
    }
  }, [statsData, reset]);

  const onSubmit = async (data) => {
    try {
      const payload = {
        ...data,
        ad_partner_id: adPartnerData.ad_partner_id,
        lang_id: data.lang_id?.value,
        position: data.position?.value,
        requests: parseInt(data.requests) || 0,
        impression: parseInt(data.impression) || 0,
        Clicks: parseInt(data.clicks) || 0,
        ecpm: parseFloat(data.ecpm) || 0,
        revenue: parseFloat(data.revenue) || 0,
        ad_code: data.ad_code || "",
        ...(statsData?.id ? { id: statsData.id } : {}),
      };

      const res = await API({
        url: payload.id ? "/adpartners/editstats" : "/adpartners/addstats",
        method: "POST",
        responseType: "json",
        data: payload,
      });

      if (res.code === 200) {
        setShow(false);
        loadData();
        loadStats();
        loadAdData();
        if(payload.ad_partner_id) loadPositionData(payload.ad_partner_id);
        Toast("success", `Stats ${payload.id ? "Updated" : "Added"} Successfully`);
        reset({
          date: "",
          requests: "",
          impression: "",
          clicks: "",
          ecpm: "",
          revenue: "",
          ad_code: "",
          lang_id: { value: 1, label: "Telugu" },
          position: { value: 0, label: "0" },
        });
        setStats({});

      } else {
        Toast("error", res.data.message);
      }
    } catch (error) {
      console.error(error);
      Toast("error", "An error occurred. Please try again.");
    }
  };

  return (
    <div className="p-4 max-w-md mx-auto">
      <h2 className="text-xl font-semibold mb-4">
        {statsData?.id ? "Edit" : "Add"} Network Ad Stats
      </h2>

      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        {[
          { name: "date", label: "Date", type: "date" },
          { name: "requests", label: "Requests", type: "number" },
          { name: "impression", label: "Impressions", type: "number" },
          { name: "clicks", label: "Clicks", type: "number" },
          { name: "ecpm", label: "eCPM", type: "number", step: "0.01" },
          { name: "revenue", label: "Revenue", type: "number", step: "0.01" },
        ].map((field) => (
          <div key={field.name}>
            <label className="block mb-1 capitalize">{field.label}</label>
            <Controller
              name={field.name}
              control={control}
              rules={{
                required: `${field.label} is required`,
                validate: (value) => {
                  if (field.type === "number" && parseFloat(value) < 0) {
                    return `${field.label} cannot be negative`;
                  }
                  return true;
                },
              }}
              render={({ field: controllerField }) => (
                <input
                  type={field.type}
                  step={field.step}
                  {...controllerField}
                  max={
                    field.name === "date"
                      ? new Date(Date.now() - 86400000).toISOString().split("T")[0]
                      : undefined
                  }
                  className="form-control w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-cyan-500"
                />
              )}
            />
            {errors[field.name] && (
              <p className="text-red-500 text-sm">{errors[field.name].message}</p>
            )}
          </div>
        ))}

        <div>
          <label className="block mb-1">Language</label>
          <Controller
            name="lang_id"
            control={control}
            rules={{ required: "Language is required" }}
            render={({ field }) => (
              <Select
                {...field}
                options={newspaperLangs}
                onChange={(option) => field.onChange(option)}
                className="text-sm"
              />
            )}
          />
          {errors.lang_id && (
            <p className="text-red-500 text-sm">{errors.lang_id.message}</p>
          )}
        </div>

        <div>
          <label className="block mb-1">Position</label>
          <Controller
            name="position"
            control={control}
            rules={{ required: "Position is required" }}
            render={({ field }) => (
              <Select
                {...field}
                options={positionOptions}
                onChange={(option) => field.onChange(option)}
                className="text-sm"
              />
            )}
          />
          {errors.position && (
            <p className="text-red-500 text-sm">{errors.position.message}</p>
          )}
        </div>
          <div>
            <label className="block mb-1 capitalize">Ad Code</label>
            <Controller
              name="ad_code"
              control={control}
              rules={{
                required: "Ad Code is required",
              }}
              render={({ field }) => (
                <input
                  type="text"
                  {...field}
                  className="form-control w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-cyan-500"
                />
              )}
            />
            {errors.ad_code && (
              <p className="text-red-500 text-sm">{errors.ad_code.message}</p>
            )}
          </div>

        <SlButton
          type="submit"
          variant="primary"
          size="medium"
          className="w-full bg-cyan-500 hover:bg-cyan-600 text-white"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Submitting..." : statsData?.id ? "Update" : "Submit"}
        </SlButton>
      </form>
    </div>
  );
}

export default NetworkAdStats;